// ****************************************************************
// Definition globale Funktionen
// ****************************************************************

import firebase from 'firebase/compat/app'

export const sumArray = (obj) => {
  if (obj) {
    const values = Object.values(obj)
    return values.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue), 0)
  } else {
    return 0
  }
}

export const getCurrentBbr = function () {
  let bbr = ''
  if (firebase.auth().currentUser) {
    this.$store.state.bbrbbr.bbrbbr.forEach(item => {
      if (item.anmeldeID === firebase.auth().currentUser.uid) {
        bbr = item.id
      }
    })
  }
  return bbr
}

export const selectLeibvater = function () {
  let selectLeibvater = []
  this.$store.getters['bbrbbr/nurBbrbbr'].forEach(bbr => {
    selectLeibvater.push({
      id: bbr.id,
      value: bbr.id,
      name: bbr.nachname + ', ' + bbr.vorname,
      text: bbr.nachname + ', ' + bbr.vorname
    })
  })
  return selectLeibvater
}



// WEBPACK FOOTER //
// ./src/main_funktionen.js